import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _isNativeReflectConstruct from "@babel/runtime/helpers/isNativeReflectConstruct";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
import { Component } from 'react';
export var ErrorBoundary = /*#__PURE__*/function (_Component) {
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _callSuper(this, ErrorBoundary, [props]);
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _inherits(ErrorBoundary, _Component);
  return _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      var _this$props$onError, _this$props;
      // Call the onError callback if provided
      (_this$props$onError = (_this$props = this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props, error, errorInfo);

      // Default error logging
      console.error('Error caught by ErrorBoundary:', error, errorInfo);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props$resetKeys, _prevProps$resetKeys;
      // biome-ignore lint/style/useBlockStatements: single-line early return
      if (!this.state.hasError) return;
      var a = (_this$props$resetKeys = this.props.resetKeys) !== null && _this$props$resetKeys !== void 0 ? _this$props$resetKeys : [];
      var b = (_prevProps$resetKeys = prevProps.resetKeys) !== null && _prevProps$resetKeys !== void 0 ? _prevProps$resetKeys : [];
      var changed = a.length !== b.length || a.some(function (v, i) {
        return v !== b[i];
      });
      // biome-ignore lint/style/useBlockStatements: single-line early return
      if (changed) this.setState({
        hasError: false,
        error: undefined
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        var _this$props$fallback;
        // biome-ignore lint/style/useBlockStatements: single-line early return
        if (this.props.fallbackRender) return this.props.fallbackRender(this.state.error);
        return (_this$props$fallback = this.props.fallback) !== null && _this$props$fallback !== void 0 ? _this$props$fallback : null;
      }
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      return {
        hasError: true,
        error: error
      };
    }
  }]);
}(Component);